// extracted by mini-css-extract-plugin
export default {"dots-container":"PaginationDots_dots-container__4DFpg","dot-active":"PaginationDots_dot-active__A6Wx1","dot-inactive":"PaginationDots_dot-inactive__zTcYS"};